import { makeStyles } from '@material-ui/core/styles'

export const buttonsStyles = makeStyles((theme) => ({
    closeModal: {
        fontSize: 48,
        fontWeight: 600,
        color: '#33949E',
        marginRight: 30
    },
    saveButton: {
        marginRight: theme.spacing(1),
        padding: theme.spacing(1),
        borderWidth: 1,
        backgroundColor: '#28a745',
        borderColor: '#28a745',
        color: '#FFFFFF',
        borderRadius: 5,
        borderStyle: 'solid',
        textAlign: 'center',
        '&:hover, &:focus': {
            backgroundColor: '#28a745',
            color: '#FFFFFF',
        },
        marginBottom: 10
    },
    cancelButton: {
        marginRight: theme.spacing(1),
        padding: theme.spacing(1),
        backgroundColor: '#dc3545',
        borderWidth: 1,
        color: '#FFFFFF',
        borderColor: '#dc3545',
        borderRadius: 5,
        borderStyle: 'solid',

        textAlign: 'center',
        '&:hover, &:focus': {
            backgroundColor: '#dc3545',
            color: '#FFFFFF',
        },
        marginBottom: 10
    },
    buttonsWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    closeModalE: {
        color: 'white', display: 'flex', justifyContent: 'end', padding: 15, fontSize: 20
    },
    unselect: {
        fontWeight: 700,
        cursor: 'pointer',
        color: 'white',
        marginLeft: 10
    },
    createBtn: {
        width: '100%',
        borderStyle: 'solid',
        borderWidth: 1,
        backgroundColor: '#33949F',
        borderColor: '#33949F',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
        padding: 15,
        color: 'white',
        '&:hover, &:focus': {
            backgroundColor: '#33949F',
            color: '#FFFFFF',
        },
    },
    seeEscapeRoomBtn: {
        backgroundColor: '#33949E',
        color: 'white',
        padding: 10,
        width: '100%',
        '&:hover': {
            backgroundColor: '#33949F',
            color: '#FFFFFF',
        },
    },
    unselectFile: {
        marginLeft: 10,
        cursor: 'pointer',
        backgroundColor: '#33949E',
        color: 'white',
        padding: 5,
        '&:hover': {
            backgroundColor: '#33949F',
            color: '#FFFFFF',
        },
    },
    monitorBtn: {
        borderStyle: 'solid',
        borderWidth: 1,
        backgroundColor: '#33949F',
        borderColor: '#33949F',
        borderRadius: 30,
        marginRight: 15,
        padding: '5px 32px',
        color: 'white',
        '&:hover, &:focus': {
            backgroundColor: '#33949F',
            color: '#FFFFFF',

        },
    },
    deleteProfile: {
        backgroundColor: '#dc3545',
        borderWidth: 1,
        color: '#FFFFFF',
        borderColor: '#dc3545',
        borderRadius: 10,
        borderStyle: 'solid',

        textAlign: 'center',
        '&:hover, &:focus': {
            backgroundColor: '#dc3545',
            color: '#FFFFFF',
        },
        marginBottom: 10
    },
    chooseTask: {
        width: '100%',
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#33949F',
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
        padding: 10,
        color: 'white',
        backgroundColor: '#33949F',
    }

}))
